import FilteringCapabilitiesDto from "../../../dtos/FilteringCapabilitiesDto";

class GetTableFilteringCapabilitiesResult {
    FilteringCapabilities: FilteringCapabilitiesDto[];

    constructor(filteringCapabilities: FilteringCapabilitiesDto[]) {
        this.FilteringCapabilities = filteringCapabilities;
    }
}

export default GetTableFilteringCapabilitiesResult;
